import { ApiConcept, ApiConceptRelation } from 'types/swagger/clarifai-api';
import toastMessage from 'components/ToastMessage/ToastMessage';

export type GetRelationRequest = {
  appConcept: ApiConcept;
  aiConcept: ApiConcept;
  allConceptRelations: ApiConceptRelation[];
};

export const getRelation = ({ allConceptRelations, appConcept, aiConcept }: GetRelationRequest) => {
  if (allConceptRelations.length === 0) return undefined;
  if (!appConcept?.id || !appConcept?.name || !appConcept?.app_id || !appConcept?.user_id) return undefined;
  if (!aiConcept?.id || !aiConcept?.name || !aiConcept?.app_id || !aiConcept?.user_id) return undefined;

  const matchedConceptRelations = allConceptRelations.filter((relation) => {
    const objectConceptId = relation?.object_concept?.id;
    const objectConceptAppId = relation?.object_concept?.app_id;
    const objectConceptUserId = relation?.object_concept?.user_id;
    if (!objectConceptId || !objectConceptAppId || !objectConceptUserId) return false;

    const subjectConceptId = relation?.subject_concept?.id;
    const subjectConceptAppId = relation?.subject_concept?.app_id;
    const subjectConceptUserId = relation?.subject_concept?.user_id;
    if (!subjectConceptId || !subjectConceptAppId || !subjectConceptUserId) return false;

    const matchObjectConceptId = objectConceptId === aiConcept.id;
    const matchObjectConceptAppId = objectConceptAppId === aiConcept.app_id;
    const matchObjectConceptUserId = objectConceptUserId === aiConcept.user_id;
    const isObjectMatched = matchObjectConceptId && matchObjectConceptAppId && matchObjectConceptUserId;

    const matchSubjectConceptId = subjectConceptId === appConcept.id;
    const matchSubjectConceptAppId = subjectConceptAppId === appConcept.app_id;
    const matchSubjectConceptUserId = subjectConceptUserId === appConcept.user_id;
    const isSubjectMatched = matchSubjectConceptId && matchSubjectConceptAppId && matchSubjectConceptUserId;

    return isObjectMatched && isSubjectMatched;
  });

  if (matchedConceptRelations.length > 1) {
    console.error('getRelation: Too many valid relations.');
    toastMessage.error('getRelation: Too many valid relations.');
    return undefined;
  }

  if (matchedConceptRelations.length === 1) return matchedConceptRelations[0];

  return undefined;
};
